var map = {
	"./back-arrow.svg": 2,
	"./background-blue-mobile.svg": 3,
	"./background-blue.svg": 4,
	"./change-password.svg": 5,
	"./download-animated.svg": 6,
	"./download.svg": 7,
	"./dropdown-arrow.svg": 8,
	"./hide.svg": 9,
	"./installation.svg": 10,
	"./language.svg": 11,
	"./logout.svg": 12,
	"./nav-arrow-gray.svg": 13,
	"./nav-arrow.svg": 14,
	"./sales.svg": 15,
	"./sample.svg": 16,
	"./setup.svg": 17,
	"./show.svg": 18,
	"./user.svg": 19,
	"./video-button.svg": 20
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1;